import { createSlice } from '@reduxjs/toolkit';
import {
    getPaginateitems,
    getShopsByMcatID,
    getItemMcatIDandSubCat,
    getAllItems,
    addItem,
    updateItem,
    getItembyIdOfcView,
    getItemInfoOfcView,
    itemtatusChange,
    homeLoadItems
} from '../actions/ItemAction'




export const itemsReducerSlice = createSlice({
    name:'itemsReducer',
    initialState:{
        homeSort:{
            sortby:"_id",
            order:"desc",
            limit:2,
            skip:0
        },
        loading:false,
        items:[],
        shops:[],
        mItems:[],
        current:null,
        mCategories:[],
        sCategories:[],
        images:[],
        status:null,
        currentContent:null,
        currentAdress:null,
        currentCntInfo:null,
        currentTimenfo:null,
   

    },
    reducers:{

        updateCategories:(state,action)=>{
            state.mCategories = action.payload
        }
    }
 ,extraReducers:(builder)=>{
    builder
  // GET PAGINATE ARTICLES
  .addCase(getPaginateitems.pending,(state)=>{ state.loading = true })
  .addCase(getPaginateitems.fulfilled,(state,action)=>{ 
    state.loading = false;
    console.log("444555");
    console.log(action.payload);
    console.log("333");
   
      state.items= action.payload 
      state.loading = false;
      console.log(state.shops);
    console.log("333");
  })
  .addCase(getPaginateitems.rejected,(state)=>{ state.loading = false })



  // GET SHOPS BY MCATID 
  .addCase(getShopsByMcatID.pending,(state)=>{ state.loading = true })
  .addCase(getShopsByMcatID.fulfilled,(state,action)=>{ 
    state.loading = false;
    console.log("444555");
    console.log(action.payload);
    console.log("333");
   
      state.shops= action.payload 
      state.loading = false;
      console.log(state.shops);
    console.log("333");
  })
  .addCase(getShopsByMcatID.rejected,(state)=>{ state.loading = false })



  // GET ITEMS BY MCATID AND SUBCATID
  .addCase(getItemMcatIDandSubCat.pending,(state)=>{ state.loading = true })
  .addCase(getItemMcatIDandSubCat.fulfilled,(state,action)=>{ 
    state.loading = false;
    console.log("444555");
    console.log(action.payload);
    console.log("333");
   
      state.mItems= action.payload 
      state.loading = false;
      console.log(state.shops);
    console.log("333");
  })
  .addCase(getItemMcatIDandSubCat.rejected,(state)=>{ state.loading = false })


  // GET ALL ITEMS  ITEMS 
  .addCase(getAllItems.pending,(state)=>{ state.loading = true })
  .addCase(getAllItems.fulfilled,(state,action)=>{ 
    state.loading = false;
    console.log("444555");
    console.log(action.payload);
    console.log("333");
   
      state.mItems= action.payload 
      state.loading = false;
      console.log(state.shops);
    console.log("333");
  })
  .addCase(getAllItems.rejected,(state)=>{ state.loading = false })

    // ADD SHOP
    .addCase(addItem.pending,(state)=>{ state.loading = true })
    .addCase(addItem.fulfilled,(state,action)=>{ 
        state.loading = false;
        state.lastAdded = action.payload 
    })
    .addCase(addItem.rejected,(state)=>{ state.loading = false })


    // UPDATE SHOP
    .addCase(updateItem.pending,(state)=>{ state.loading = true })
    .addCase(updateItem.fulfilled,(state,action)=>{ 
        state.loading = false;
        state.lastAdded = action.payload 
    })
    .addCase(updateItem.rejected,(state)=>{ state.loading = false })


    //getItemtailsforOfcUse
.addCase(getItembyIdOfcView.pending,(state)=>{ state.loading = true })
.addCase(getItembyIdOfcView.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.current = action.payload
})
.addCase(getItembyIdOfcView.rejected,(state)=>{ state.loading = false })


//getShopDetailsforOfcUse
.addCase(getItemInfoOfcView.pending,(state)=>{ state.loading = true })
.addCase(getItemInfoOfcView.fulfilled,(state,action)=>{ 
    console.log("999999999999");
    console.log(action.payload);
    console.log("999999999999");
    state.loading = false;
    state.current = action.payload
})
.addCase(getItemInfoOfcView.rejected,(state)=>{ state.loading = false })


//STATUS CHANGE OF THE ITEM
.addCase(itemtatusChange.fulfilled,(state,action)=>{ 
  state.status = action.payload;

  console.log("3333333");
  console.log(action.payload);
  console.log("3333333");
})

// HOME LOAD MORE
.addCase(homeLoadItems.fulfilled,(state,action)=>{ 

  console.log("77777777777");
  state.homeSort.skip = action.payload.sort.skip
  state.items = action.payload.newState
})

  //end
}
})
export const { updateMnCategories } = itemsReducerSlice.actions
export default itemsReducerSlice.reducer;